module.exports = __webpack_public_path__ + "img/letter-l.ee44462c.svg";